module.exports = __webpack_public_path__ + "static/media/app_srm.bd25866f.svg";